/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "com.atproto.repo.getRecord";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"cid":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"cid"})),"repo":/*#__PURE__*/ l.string({"format":"at-identifier"}),"rkey":/*#__PURE__*/ l.string({"format":"record-key"}),"collection":/*#__PURE__*/ l.string({"format":"nsid"})});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"cid":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"cid"})),"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"value":/*#__PURE__*/ l.lexMap()});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get a single record from a repository. Does not require auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["RecordNotFound"]);

export { main };

export const $lxm = $nsid;
